import React, { useEffect, useState } from "react";
import { getEmployeeTravelHistory } from "../../services/Employeeservice";
import { useParams } from "react-router-dom";
import { dateRangeOptions } from "../../utilities";
import { Link } from "react-router-dom";
import {
  parse,
  format,
  isValid,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
const EmployeeTravelHistory = () => {
  const { id } = useParams();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dateRangeOptions[1]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [param, setParam] = useState({
    query: "",
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    page: "1",
    page_size: "10",
  });
  useEffect(() => {
    setLoading(true);
    getEmployeeTravelHistory(id, param)
      .then((res) => {
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
    });
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  return (
    <div>
      <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-3 py-2">
        <div className="flex-fill flex-md-grow-0">
          {/* <small className="text-dark">Search here</small> */}
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
        </div>
        <div className="d-flex flex-column flex-md-row gap-2">
          {showDatePicker && (
            <div className="flex-fill flex-md-grow-0">
              {/* <small className="text-dark">Select Date</small> */}
              <DatePicker
                selectsRange
                startDate={
                  param?.start_date ? new Date(param.start_date) : null
                }
                endDate={param?.end_date ? new Date(param.end_date) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setParam((prev) => ({
                    ...prev,
                    start_date: start ? format(start, "yyyy-MM-dd") : "",
                    end_date: end ? format(end, "yyyy-MM-dd") : "",
                    page: 1,
                  }));
                }}
                isClearable
                placeholderText="Select date range"
                className="form-control"
                style={{
                  fontSize: "0.5rem",
                }}
                popperProps={{
                  modifiers: [
                    {
                      name: "zIndex",
                      enabled: true,
                      phase: "beforeWrite",
                      fn({ state }) {
                        state.styles.popper.zIndex = 999;
                      },
                    },
                  ],
                }}
              />
            </div>
          )}
          <div className="flex-fill flex-md-grow-0">
            {/* <small className="text-dark">Select Period</small> */}
            <Select
              options={dateRangeOptions}
              onChange={handleSelectChange}
              placeholder="Select Period"
              className="react-select"
              classNamePrefix="select"
              isClearable
              value={selectedOption}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        ) : data?.length == 0 ? (
          <div className="text-center my-3">No Data Found</div>
        ) : (
          <div className="table-responsive">
            {" "}
            <table className="table fs-6 mb-0">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Route</th>
                  <th>Shift</th>
                  <th>Bus</th>
                  <th>Stop</th>
                  <th>Mode</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item) => {
                  const tripModeClass =
                    item?.trip_mode?.toLowerCase() === "pickup"
                      ? "text-bg-success-soft"
                      : "text-bg-info-soft";

                  return (
                    <tr key={item.id}>
                      <td>
                        <Link
                          to={`/route/${item?.route?.id}`}
                          className="text-primary cursor-pointer fw-semibold"
                        >
                          {item?.route?.name || "N/A"}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/shift/${item?.shift?.id}`}
                          className="text-primary cursor-pointer fw-semibold"
                        >
                          {item?.shift?.name || "N/A"}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/bus/${item?.bus?.id}`}
                          className="text-primary cursor-pointer fw-semibold"
                        >
                          {item?.bus?.number_plate || "N/A"}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={`/stop/${item?.stop?.id}`}
                          className="text-primary cursor-pointer fw-semibold"
                        >
                          {item?.stop?.name || "N/A"}
                        </Link>
                      </td>
                      <td>
                        {" "}
                        <span className={`badge ${tripModeClass}`}>
                          {item?.trip_mode || "N/A"}
                        </span>
                      </td>
                      <td>{item?.created_at || "N/A"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {!loading && data && data.length > 0 && (
          <div className="px-2 border-top">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeTravelHistory;
